import type { ComponentType, SVGProps } from 'react';

import { ContainerElement } from '@/containerElement';
import { ParagraphElement } from '@/paragraphElement';
import { SerializeTextLeaf } from '@/textLeaf';
import type { WebTheme } from '@/types';

import { RSS_FEED_EPISODE_DEFAULTS } from './constants';

export const ListenOnButton = ({
  url,
  Icon,
  label,
  theme,
  iconClassName = 'w-6 h-6 shrink-0 rounded-sm overflow-hidden lg:w-4 lg:h-4',
}: {
  url: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  theme: WebTheme;
  iconClassName?: string;
}) => {
  return (
    <a href={url} target="_blank" rel="noreferrer" className="w-fit">
      <ContainerElement
        element={{
          type: 'container',
          attrs: {
            id: 'podcasts-link-container',
            padding: '8px 12px',
            mobilePadding: '8px 12px',
            backgroundColor: theme.background_color || RSS_FEED_EPISODE_DEFAULTS.pageBackgroundColor,
            borderRadius: '8px',
            mobileBorderRadius: '8px',
            borderWidth: '1px',
            width: 'fit-content',
            borderColor: 'rgba(128, 128, 128, 0.15)',
            hoverBorderColor: 'rgba(128, 128, 128, 0.3)',
            hoverBorderWidth: '1px',
            borderStyle: 'solid',
            gap: '8px',
            flexDirection: 'row',
            horizontalAlign: 'center',
          },
          content: [],
        }}
        className="cursor-pointer"
      >
        <Icon aria-hidden="true" className={iconClassName} />
        <ParagraphElement
          element={{
            type: 'paragraph',
            attrs: {
              textAlign: 'left',
              padding: '0px',
              margin: '0px',
              lineHeight: '16px',
            },
          }}
          className="whitespace-nowrap"
        >
          <SerializeTextLeaf
            leaf={{
              text: label,
              marks: [
                {
                  type: 'textStyle',
                  attrs: {
                    fontSize: 12,
                    fontFamily: 'Inter',
                    color: theme.text_on_background_color || RSS_FEED_EPISODE_DEFAULTS.descriptionTextColor,
                    fontWeight: 500,
                    lineHeight: '16px',
                  },
                },
              ],
            }}
          />
        </ParagraphElement>
      </ContainerElement>
    </a>
  );
};
